/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CREATE_PROFILE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.createProfileSave',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CREATE_PROFILE' },
      },
    },
    CREATE_PROFILE: {
      invoke: {
        id: 'createProfileSave',
        src: 'createProfileSave',
        onDone: {
          target: 'CREATE_PROFILE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_PROFILE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_PROFILE_SUCCESS: {
      on: {
        START: { target: 'CREATE_PROFILE' },
      },
    },
    CREATE_PROFILE_FAILED: {
      on: {
        START: { target: 'CREATE_PROFILE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
